import createLogicalCompositorWith from './createLogicalCompositorWith';

const andify = createLogicalCompositorWith('every');

export default andify;
